import { render, staticRenderFns } from "./ImageMessage.vue?vue&type=template&id=b2ba606c&scoped=true&"
import script from "./ImageMessage.vue?vue&type=script&lang=ts&"
export * from "./ImageMessage.vue?vue&type=script&lang=ts&"
import style0 from "./ImageMessage.vue?vue&type=style&index=0&id=b2ba606c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ba606c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VImg,VProgressCircular,VRow})
